import dayjs, { Dayjs } from "dayjs";

export const getMonthMatrix = (year: number, columns = 3): Dayjs[][] => {
  const matrix: Dayjs[][] = [];
  let row: Dayjs[] = [];

  for (let month = 0; month < 12; month++) {
    row.push(dayjs().year(year).month(month).startOf("month"));

    if (row.length === columns) {
      matrix.push(row);
      row = [];
    }
  }

  return matrix;
};
